<template>
    <div class="v-modal" :class="{['variant-' + variant]: !!variant}" @click="clickStoper">
        <div class="v-modal-header">
            <slot name="header">
                <div v-if="icon" class="v-modal-icon">
                    <i class="far" :class="{['fa-' + icon]: !!icon}"></i>
                </div>
                <h5 class="v-modal-title" v-if="title && !$slots.title">{{ title }}</h5>
                <div class="v-modal-title" v-if="$slots.title">
                    <slot name="title"></slot>
                </div>
            </slot>
            <button class="v-modal-close" @click="close"><i class="far fa-times"></i></button>
        </div>
        <div class="v-modal-body" :class="{'no-padding': noPadding}">
            <slot name="default"></slot>
            <div class="v-modal-busy" v-if="busy">
                <b-spinner label="Busy"></b-spinner>
            </div>
        </div>
        <div class="v-modal-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modal-constructor",
        props: {
            busy: {
                type: Boolean,
                default: false,
            },
            title: null,
            variant: null,
            icon: null,
            noPadding: {
                type: Boolean,
                default: false
            }
        },
        created() {
            //this.$parent.$el.addEventListener('click', e => e.stopPropagation());
            this.$parent.$el.addEventListener('special-table-click', e => e.stopPropagation());
        },
        methods: {
            close() {
                this.$emit('close');
                if (this.hasOwnProperty('parent')) {
                    this.parent.$emit('close');
                }
            },
            clickStoper(e) {
                //e.stopPropagation();
            }
        }
    }
</script>